import * as React from "react";

interface IProps extends IOnboardStepProps {
  setWizardComplete: () => void;
}

interface IState {}

class OnboardFinish extends React.Component<IProps, IState> {
  componentDidMount() {
    this.props.setWizardComplete();
  }

  render() {
    return (
      <>
        <div className="panel panel-primary">
          <div className="panel-heading">Onboarding Complete</div>
          <div className="panel-body">
            <p>You have reached the end of the onboarding wizard!</p>
            <p>
              If you need to go back and finish a section or make changes, you
              may do so by clicking the step number (or the previous step
              button). You can return to this page by using the 'Onboarding'
              button on your 'My Organization' page.
            </p>
          </div>
        </div>
      </>
    );
  }
}

export default OnboardFinish;



// WEBPACK FOOTER //
// ./app/javascript/components/onboarding/OnboardFinish.tsx